import Vue from "vue";
import Vuetify from "vuetify/lib";
import VuetifyConfirm from "vuetify-confirm";

Vue.use(Vuetify);
const vuetify = new Vuetify({});

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: "Aceptar",
  buttonFalseText: "Cancelar",
  color: "#E3002C",
  icon: "mdi-alert-octagon-outline",
  title: "Atención",
  width: 350,
  property: "$confirm"
});

export default vuetify;
